import { render, staticRenderFns } from "./CommonLayer.vue?vue&type=template&id=d08fa7f8&scoped=true&"
import script from "./CommonLayer.vue?vue&type=script&lang=js&"
export * from "./CommonLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08fa7f8",
  null
  
)

export default component.exports